import { IFilter, IFilterConfig } from 'pbc.types';

import { IBerichtsVorlage } from '.';

export interface IBerichtsVorlageFilter extends IFilter<IBerichtsVorlage> {}

export const BerichtsVorlageFilterConfig: IFilterConfig<IBerichtsVorlage> = [];

export type IBerichtsVorlageField = 'berichtsVorlage.id' | 'berichtsVorlage.name' | 'berichtsVorlage.kommentar' | 'berichtsVorlage.datei';
